import React from 'react';

/* components */
import { TutorialDone } from '../../components/Tutorial/TutorialDone.js';

export const TutorialDoneContainer = () =>
    <section>
        <TutorialDone />
    </section>;
